import { useEffect, useRef } from 'react';
import { getConnectionStatus, subscribeConnectionStatus } from '../services/connectionStatus';

/**
 * Run `callback` the moment the server is reachable again.
 *
 * While the server looks unreachable, connectionStatus probes it every 15
 * seconds, and any successful request also counts. The TV screens use this to
 * reload as soon as that happens rather than waiting out their own refresh
 * interval (45 seconds on the Transformers TV), which left "Offline" on screen
 * for most of a minute after the server was back.
 */
export function useOnReconnect(callback) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    let wasReachable = getConnectionStatus().reachable;
    const unsubscribe = subscribeConnectionStatus((status) => {
      if (status.reachable && !wasReachable) {
        callbackRef.current();
      }
      wasReachable = status.reachable;
    });
    return () => {
      unsubscribe();
    };
  }, []);
}
